export enum ReturnIntegrationProvider {
  Aims360 = "aims360",
  Apparelmagic = "apparelmagic",
  Blueyonder = "blueyonder",
  Brightpearl = "brightpearl",
  Cloudx = "cloudx",
  Flexport = "flexport",
  Inmar = "inmar",
  Linnworks = "linnworks",
  Netsuite = "netsuite",
  Returnbear = "returnbear",
  Sfom = "sfom",
  Shipbob = "shipbob",
  Shiphero = "shiphero",
  Trackstar = "trackstar",
}
